export interface ICheckPasswordResetCodeRequest {
  passwordResetCode: string;
}

export class CheckPasswordResetCodeRequest
  implements ICheckPasswordResetCodeRequest {
  passwordResetCode: string;
}
